import {translations} from 'presentation/translations-new';
import IconNamesType from 'presentation/icons/IconNamesType';
import feverIcon from 'presentation/assets/images/emergency-telehealth/fever.svg';
import headacheIcon from 'presentation/assets/images/emergency-telehealth/headache.svg';
import skinIrritationIcon from 'presentation/assets/images/emergency-telehealth/skin-irritation.svg';
import generalGuidanceIcon from 'presentation/assets/images/emergency-telehealth/general-guidance.svg';
import checkupsIcon from 'presentation/assets/images/emergency-telehealth/checkups.svg';
import medicalCertificateIcon from 'presentation/assets/images/emergency-telehealth/medical-certificate.svg';
import prescriptionRenewalIcon from 'presentation/assets/images/emergency-telehealth/prescription-renewal.svg';
import specialistReferralIcon from 'presentation/assets/images/emergency-telehealth/specialist-referral.svg';

const {keep, tryAgain} = translations['pt-br'].commons;
const {bookTelehealth} = translations['pt-br'].privateFlow.services;
const journey = translations['pt-br'].privateFlow.emergencyTelehealthJourney;

type JourneyListItem = {
	iconName: IconNamesType;
	iconSrc?: string;
	text: string;
	variant: 'primary' | 'error';
};

type JourneyStep = {
	key: 'attendance' | 'emergency' | 'whenToUse' | 'whenNotToUse';
	title: string;
	description: string;
	iconName: IconNamesType;
	iconVariant: 'primary' | 'error';
	primaryActionLabel: string;
	secondaryActionLabel?: string;
	listItems?: JourneyListItem[];
};

const EMERGENCY_TELEHEALTH_STEP_LABELS = [
	journey.stepLabels.attendance,
	journey.stepLabels.emergency,
	journey.stepLabels.whenToUse,
	journey.stepLabels.whenNotToUse,
];

const EMERGENCY_TELEHEALTH_STEPS: JourneyStep[] = [
	{
		key: 'attendance',
		title: journey.attendance.title,
		description: journey.attendance.description,
		iconName: 'video-camera-front-filled',
		iconVariant: 'primary',
		primaryActionLabel: keep,
	},
	{
		key: 'emergency',
		title: journey.emergency.title,
		description: journey.emergency.description,
		iconName: 'warning-outlined',
		iconVariant: 'error',
		primaryActionLabel: keep,
		secondaryActionLabel: journey.emergency.secondaryAction,
	},
	{
		key: 'whenToUse',
		title: journey.whenToUse.title,
		description: journey.whenToUse.description,
		iconName: 'medical-services-filled',
		iconVariant: 'primary',
		primaryActionLabel: keep,
		listItems: [
			{
				iconName: 'emoticon-happy-outline',
				iconSrc: feverIcon,
				text: journey.whenToUse.items.fever,
				variant: 'primary',
			},
			{
				iconName: 'face',
				iconSrc: headacheIcon,
				text: journey.whenToUse.items.headache,
				variant: 'primary',
			},
			{
				iconName: 'fluid-default',
				iconSrc: skinIrritationIcon,
				text: journey.whenToUse.items.skinIrritation,
				variant: 'primary',
			},
			{
				iconName: 'medical-services-filled',
				iconSrc: generalGuidanceIcon,
				text: journey.whenToUse.items.generalGuidance,
				variant: 'primary',
			},
		],
	},
	{
		key: 'whenNotToUse',
		title: journey.whenNotToUse.title,
		description: journey.whenNotToUse.description,
		iconName: 'medical-services-filled',
		iconVariant: 'error',
		primaryActionLabel: journey.whenNotToUse.primaryAction,
		secondaryActionLabel: bookTelehealth,
		listItems: [
			{
				iconName: 'heart-outline',
				iconSrc: checkupsIcon,
				text: journey.whenNotToUse.items.checkups,
				variant: 'error',
			},
			{
				iconName: 'accessible-filled',
				iconSrc: medicalCertificateIcon,
				text: journey.whenNotToUse.items.medicalCertificate,
				variant: 'error',
			},
			{
				iconName: 'assignment-outline',
				iconSrc: prescriptionRenewalIcon,
				text: journey.whenNotToUse.items.prescriptionRenewal,
				variant: 'error',
			},
			{
				iconName: 'doctor-filled',
				iconSrc: specialistReferralIcon,
				text: journey.whenNotToUse.items.specialistReferral,
				variant: 'error',
			},
		],
	},
];

const EMERGENCY_TELEHEALTH_ERROR_STATE = {
	title: journey.error.title,
	description: journey.error.description,
	buttonLabel: tryAgain,
};

const EMERGENCY_TELEHEALTH_EXIT_MODAL = {
	headerTitle: journey.exitModal.headerTitle,
	title: journey.exitModal.title,
	description: journey.exitModal.description,
	primaryButton: journey.exitModal.primaryButton,
	secondaryButton: journey.exitModal.secondaryButton,
};

export {
	EMERGENCY_TELEHEALTH_ERROR_STATE,
	EMERGENCY_TELEHEALTH_EXIT_MODAL,
	EMERGENCY_TELEHEALTH_STEPS,
	EMERGENCY_TELEHEALTH_STEP_LABELS,
};
